import { useState, useEffect, useRef } from 'react'
import { creatorService } from '../../services/creator.service'
import { httpService } from '../../services/http.service'
import { setUpperPopup } from '../../store/actions/general.actions'
import { useDispatch } from 'react-redux'
import { Loader } from '../loader'

export function Updates() {
    const dispatch = useDispatch()
    const [updates, setUpdates] = useState([])
    const [loading, setLoading] = useState(true)
    const [submitting, setSubmitting] = useState(false)
    const [showForm, setShowForm] = useState(false)
    const [imagePreview, setImagePreview] = useState(null)
    const [type, setType] = useState('none')
    const [link, setLink] = useState('')
    const imageRef = useRef(null)

    useEffect(() => {
        loadUpdates()
    }, [])

    const loadUpdates = async () => {
        try {
            const data = await creatorService.getUpdates()
            setUpdates(data)
        } catch (err) {
            console.log(err)
        } finally {
            setLoading(false)
        }
    }

    const handleImageChange = (e) => {
        const file = e.target.files[0]
        if (file && file.type.startsWith('image/')) {
            setImagePreview(URL.createObjectURL(file))
        }
    }

    const handleSubmit = async () => {
        if (!imageRef.current?.files[0]) return
        try {
            setSubmitting(true)
            const imageUrl = await httpService.uploadImage(imageRef.current.files[0])
            const newUpdate = await creatorService.addUpdate({
                image: imageUrl,
                type,
                link: type !== 'none' ? link : ''
            })
            setUpdates([newUpdate, ...updates])
            resetForm()
        } 
        catch (err) {
            if(err.status === 406) dispatch(setUpperPopup('max-updates'))
        } 
        finally {
            setSubmitting(false)
        }
    }

    const handleDelete = async (id) => {
        try {
            await creatorService.deleteUpdate(id)
            setUpdates(updates.filter(u => u._id !== id))
        } 
        catch (err) {
            dispatch(setUpperPopup('errorServer'))
        }
    }

    const resetForm = () => {
        setShowForm(false)
        setImagePreview(null)
        setType('none')
        setLink('')
        if (imageRef.current) imageRef.current.value = ''
    }

    if (loading) return <div className="updates"><Loader /></div>

    return (
        <div className="updates">
            <p>Internal Links on app : chat,home,profile, bots/shoval,bots/ori</p>
            <div className="updates-header">
                <h2>Updates</h2>
                {!showForm && (
                    <button className="add-btn" onClick={() => setShowForm(true)}>
                        <span className="material-symbols-outlined">add</span>
                        Add Update
                    </button>
                )}
            </div>

            {showForm && (
                <div className="update-form">
                    <input
                        type="file"
                        ref={imageRef}
                        accept="image/*"
                        onChange={handleImageChange}
                        className="non-appear"
                        id="update-image"
                    />
                    <label htmlFor="update-image" className="image-upload">
                        {imagePreview ? (
                            <img src={imagePreview} alt="Preview" />
                        ) : (
                            <div className="placeholder">
                                <span className="material-symbols-outlined">add_photo_alternate</span>
                                <p>Upload Image (Required)</p>
                            </div>
                        )}
                    </label>

                    <div className="form-fields">
                        <div className="field">
                            <label>Link type</label>
                            <select value={type} onChange={(e) => setType(e.target.value)}>
                                <option value="none">None</option>
                                <option value="internal">Internal</option>
                                <option value="external">External</option>
                            </select>
                        </div>

                        {type !== 'none' && (
                            <div className="field">
                                <label>Link</label>
                                <input
                                    type="url"
                                    value={link}
                                    onChange={(e) => setLink(e.target.value)}
                                    placeholder={type === 'internal' ? "Enter page name (like home)" : "Enter external link..."}
                                />
                            </div>
                        )}
                    </div>

                    <div className="form-actions">
                        {submitting ? <Loader /> : (
                            <>
                                <button className="cancel-btn" onClick={resetForm}>Cancel</button>
                                <button
                                    className="submit-btn"
                                    onClick={handleSubmit}
                                    disabled={!imagePreview}
                                >
                                    Add Update
                                </button>
                            </>
                        )}
                    </div>
                </div>
            )}

            <div className="updates-list">
                {updates.length === 0 ? (
                    <p className="no-updates">No updates yet</p>
                ) : (
                    updates.map(update => (
                        <div key={update._id} className="update-card">
                            <img src={update.image} alt="Update" />
                            <div className="update-info">
                                <span className={`type-badge ${update.type}`}>{update.type}</span>
                                {update.link && <a href={update.link} target="_blank" rel="noreferrer">{update.link}</a>}
                            </div>
                            <button className="delete-btn" onClick={() => handleDelete(update._id)}>
                                <span className="material-symbols-outlined">delete</span>
                            </button>
                        </div>
                    ))
                )}
            </div>
        </div>
    )
}
